export default __webpack_public_path__ + "static/coins-3f1c055050d364afeddcec1ff7681af7.jpg";